import { ICommonSettings } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { WhatsappBusinessSettings } from "./app-settings-config-whatsapp-business";

export interface IWhatsappBusinessInputState {
  showModal: boolean;
  editingWhatsappBusinessId: string;
}

export interface IWhatsappBusinessInputProps {
  parentConfigValue?: string | null;
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleUpdateCustomFormInput?: (formItemName: string[], value: string | null) => void;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class WhatsappBusinessInput extends PureComponent<IWhatsappBusinessInputProps, IWhatsappBusinessInputState> {
  formInputName = ["apiConfig", "whatsappBusinessSettingsId"];

  constructor(props: IWhatsappBusinessInputProps) {
    super(props);
    this.state = {
      showModal: false,
      editingWhatsappBusinessId: ""
    };
  }

  openModal = () => {
    this.setState({ showModal: true, editingWhatsappBusinessId: "" });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  setEditingSetting = (id: string) => {
    this.setState({ editingWhatsappBusinessId: id, showModal: true });
  };

  handleRestore = (): void => {
    this.props.handleUpdateCustomFormInput?.(this.formInputName, this.props.parentConfigValue ?? null);
  };

  render() {
    const {
      parentConfigValue,
      commonSettings,
      getSectionDescription,
      handleUpdateCustomFormInput,
      handleCreateCommonConfig,
      handleUpdateCommonConfig,
      handleDeleteCommonConfig
    } = this.props;
    return (
      <>
        <WhatsappBusinessSettings
          formInputName={this.formInputName}
          closeModal={this.closeModal}
          showModal={this.state.showModal}
          editingWhatsappBusinessId={this.state.editingWhatsappBusinessId}
          commonSettings={commonSettings}
          getSectionDescription={getSectionDescription}
          handleCreateCommonConfig={handleCreateCommonConfig}
          handleUpdateCommonConfig={handleUpdateCommonConfig}
          handleDeleteCommonConfig={handleDeleteCommonConfig}
        />
        <div style={{ marginTop: 16 }}>
          <ConfigSettingSelect
            label="Configuration"
            formInputName={this.formInputName}
            options={this.props.commonSettings?.whatsappBusinessSettings ?? []}
            allowClear
            tooltipContentKey="appsettings_whatsappbusiness_configuration"
            onAddNew={this.openModal}
            onEdit={this.setEditingSetting}
            parentConfigValue={this.props.parentConfigValue}
            onRestore={this.handleRestore}
            dropdownTestId="appSettingsWhatsappBusinessDropdown"
            addNewTestId="appSettingsWhatsappBusinessAddNewButton"
            editTestId="appSettingsWhatsappBusinessEditButton"
          />
        </div>
      </>
    );
  }
}
